module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/FairTradeHighGrowth_Chocolonely_bg.818ceb3c.jpg";